import { render, staticRenderFns } from "./changeDutyList.vue?vue&type=template&id=7a351b17&scoped=true"
import script from "./changeDutyList.vue?vue&type=script&lang=js"
export * from "./changeDutyList.vue?vue&type=script&lang=js"
import style0 from "./changeDutyList.vue?vue&type=style&index=0&id=7a351b17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a351b17",
  null
  
)

export default component.exports